export default {
  SET_CONTACTS(state, contacts) {
    state.contacts = contacts
  },
  REMOVE_CONTACT(state, itemId) {
      const accountIndex = state.contacts.datas.findIndex((u) => u.id == itemId)
      state.contacts.datas.splice(accountIndex, 1)
  },
  SELECTED_CONTACT(state,data){
    state.contacts.datas = []
    state.contacts.total = 1;
    state.contacts.per_page = 1;
    state.contacts.datas.push(data)
  },
  SET_PHONE_TYPES(state,phone_types){
    state.phone_types = phone_types
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  SET_VERTICALS(state,data){
    state.verticals = data
  },
  SET_COUNTRIES(state,data){
    state.countries = data
  },
  SET_CONTACT(state,data){
    state.contact_or_company = data
  },
  SET_SENIORITIES(state,data){
    state.seniorities = data
  },
  SET_ROLES(state,data){
    state.roles = data
  },
  SET_SUB_ROLES(state,data){
    state.sub_roles = data
  },
}
